/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function UpdateKOInformation(formData) {
  const response = await $.soap({
    body: {
      UpdateKOInformation: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        KOInformation: {
          ID: formData.id,
          Name: formData.name,
          POCFirstName: formData.pocFirstName,
          POCLastName: formData.pocLastName,
          POCEmail: formData.pocEmail,
          POCPhone: formData.pocPhone,
          POCFax: formData.pocFax,
          PGr: formData.pgr,
          PGCCode: formData.pgcCode,
          AddressID: formData.address.addressId,
          Address1: formData.address.addressLine1,
          BuildingFloorNumber: formData.address.buildingFloorNumber,
          RoomPoleNumber: formData.address.roomPoleNumber,
          City: formData.address.city,
          Zip: formData.address.zip,
          RegionID: formData.address.regionId,
          RegionGroupID: formData.regionGroupId,
          IsActive: formData.isActive
        }
      }
    },
    blueprint: {
      id: '$..ID'
    }
  });

  cleanUpResponse(response);
  return response.id;
}
